import { render, staticRenderFns } from "./PrkObserver.vue?vue&type=template&id=f5179d42&"
import script from "./PrkObserver.vue?vue&type=script&lang=js&"
export * from "./PrkObserver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports